<template>
  <div class="mt-sm-4">
    <div v-if="!user_id">
      <button class="btn btn-info mw" @click="sendRequest">
        {{ "get_access" | setText("Получить доступ APEX") }}
      </button>
    </div>

    <component
      v-if="user_id"
      :is="data.type"
      :currentRequest="currentRequest"
      :data="data"
      v-model="setValue"
      :user_id="user_id"
    />
  </div>
</template>
<script>
import { errorNotify } from "../../../plugins/functions";

export default {
  methods: {},
  components: {
    smartphone: () => import("./smartphone"),
    car: () => import("./car"),
  },
  methods: {
    async sendRequest() {
      this.$loading(true);
      const url = `${this.currentRequest.service.api_endpoint_url}users`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };
      //DATA
      let data = {
        email: this.$store.state.user.email,
        // email: "DJAKHONGIR.UTEMURATOV@UCELl.UZ",
      };

      //REQUEST
      return this.$http({
        method: method,
        data: data,
        url: url,
        headers: headers,
      })
        .then((response) => {
          const responseData = response.data;
          if (responseData) {
            switch (responseData.result) {
              case 0:
                this.user_id = responseData.user_id;
                break;

              default:
                break;
            }

            if (responseData.result_message) {
              this.$notify({
                title: "APEX",
                message: responseData.result_message,
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            }
          }

          return responseData;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data: () => ({
    user_id: null,
  }),
  props: ["value", "data"],
  computed: {
    requests() {
      return this.data.service_requests.filter(
        (item) => item && item.service && item.service.code === "apex"
      );
    },
    currentRequest() {
      try {
        return this.requests[0];
      } catch (error) {}

      return null;
    },
    state() {
      return this.currentRequest && this.currentRequest["state"]
        ? this.currentRequest["state"]
        : "cancel";
    },
    setValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
</style>
 